export default __webpack_public_path__ + "static/offshore-8b006e512e3a3bddff7c6bab498ad607.webp";